var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"name":"view-tag-info","esc-to-close":false,"title":_vm.title,"width":"65%","hide-footer":""},on:{"before-open":_vm.beforeOpen}},[_c('app-form',{ref:"form",attrs:{"schema":_vm.schema,"data":_vm.formModel}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1a85624","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/tag/view-tag-info.vue
// module id = Llav
// module chunks = 23